import React, {useCallback} from 'react';
import _AccordionSummary from '@material-ui/core/AccordionSummary';
import _Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import {SessionInfoTable, SessionInfoTableRow} from 'module/SessionInfo/component/modal/SessionInfoTable';
import {getSisDateAsISO} from 'util/SisDateTime';
import HelpOutlinedIcon from '@material-ui/icons/HelpOutlined'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import PowerSettingsNewIcon from '@material-ui/icons/PowerSettingsNew'
import {Modal as Modal} from 'module/Modal/component/Modal';
import {ChangePasswordComponent} from 'module/SessionInfo/component/password/ChangePasswordComponent';
import Button from '@material-ui/core/Button';
import {SwitchUserComponent} from 'module/SessionInfo/component/userInfo/SwitchUserComponent';
import {KostComponent} from 'module/SessionInfo/component/kost/KostComponent';
import {VlErrorList as _VlErrorList} from 'module/PersonInfo/component/VlErrorList';
import {VorgesetzterUserSelect} from 'module/SessionInfo/component/userInfo/VorgesetzterUserSelect';
import {MandantSelect} from 'module/SessionInfo/component/userInfo/MandantSelect';
import {EwsRepSelectList} from 'module/SessionInfo/component/userInfo/EwsRepSelectList';
import {PersonInfoList as _PersonInfoList} from 'module/PersonInfo/component/PersonInfoList';
import withStyles from '@material-ui/core/styles/withStyles';
import {logout, openHelp} from 'module/SessionInfo/api/SessionInfoAPI';
import DialogActions from '@material-ui/core/DialogActions';
import {useDispatch, useSelector} from 'react-redux';
import {DeleteLocalCacheButton} from 'component/DeleteLocalCacheButton';
import Paper from '@material-ui/core/Paper';
import {ModalKey} from 'module/Modal/type/ModalKey';
import {selSessionInfoData, selSessionInfoExpanded} from 'module/SessionInfo/selector/SessionInfoSelector';
import {sessionInfoExpandAction} from 'module/SessionInfo/action/SessionInfoAction';

const PersonInfoList = withStyles({
	root: {
		fontSize: 'medium',
	},
})(_PersonInfoList);

const VlErrorList = withStyles({
	root: {
		maxHeight: 500,
		overflow: 'auto',
	},
})(_VlErrorList);

const ExpansionPanel = withStyles(({
	root: {
		'&$expanded': {
			margin: 0,
		},
	},
	expanded: {
		margin: 0,
	},
}))(_Accordion);

const ExpansionPanelSummary = withStyles(theme => ({
	root: {
		background: theme.palette.primary.main,
		color: theme.palette.getContrastText(theme.palette.primary.main),
		minHeight: theme.spacing(6),
		'&$expanded': {
			minHeight: theme.spacing(6),
		},
	},
	expanded: {
		marginBottom: theme.spacing(2),
	},
	expandIcon: {
		margin: 0,
		color: theme.palette.getContrastText(theme.palette.primary.main),
	},
	content: {
		'&$expanded': {
			margin: theme.spacing(1.5, 0),
		},
	},
}))(_AccordionSummary);

const DialogActionsPaper = withStyles({root: {position: 'sticky', bottom: 0}})(Paper);

const MODAL_KEY = ModalKey.SessionInfo;
const panelProps = {TransitionProps: {unmountOnExit: true}};

export const SessionInfoModal = React.memo(() => {
	const data = useSelector(selSessionInfoData);
	const expanded = useSelector(selSessionInfoExpanded)
	const expandedUser = expanded.User
	const expandedCostCenter = expanded.CostCenter
	const expandedCalculation = expanded.Calculation
	const expandedPersonalInfo = expanded.PersonalInfo
	const expandedPassword = expanded.Password

	const dispatch = useDispatch();
	const expandedUserCb = useCallback((evt, value) => dispatch(sessionInfoExpandAction({name: 'User', expanded: Boolean(value)})), [])
	const expandedCostCenterCb = useCallback((evt, value) => dispatch(sessionInfoExpandAction({name: 'CostCenter', expanded: Boolean(value)})), [])
	const expandedCalculationCb = useCallback((evt, value) => dispatch(sessionInfoExpandAction({name: 'Calculation', expanded: Boolean(value)})), [])
	const expandedPersonalInfoCb = useCallback((evt, value) => dispatch(sessionInfoExpandAction({name: 'PersonalInfo', expanded: Boolean(value)})), [])
	const expandedPasswordCb = useCallback((evt, value) => dispatch(sessionInfoExpandAction({name: 'Password', expanded: Boolean(value)})), [])

	if (!data) return null;
	const {
		evoAppsUser, costCenter, calculation, personalInfo, ewsRepList,
		vorgztUserRendered, mailVertretungRendered, passwordPanelRendered,
	} = data;
	const showVorgesetzterSelect = vorgztUserRendered === true;
	const showAltMandantSelect = evoAppsUser.defaultMandant != null;
	const {mandant, alternativeMandants, defaultMandant, vorgesetzterUser} = evoAppsUser;

	return (
		<Modal
			modalKey={MODAL_KEY}
			disableAutoFocus={true}
			title={'Benutzerinformationen'}
		>
			<ExpansionPanel
				{...panelProps}
				expanded={expandedUser}
				onChange={expandedUserCb}
			>
				<ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
					Benutzerdaten
				</ExpansionPanelSummary>
				<AccordionDetails>
					<form noValidate autoComplete="off" style={{width: '100%'}}>
						<SessionInfoTable>
							<SessionInfoTableRow label={'Benutzer'}>
								<SwitchUserComponent evoAppsUser={evoAppsUser}/>
							</SessionInfoTableRow>
							{showVorgesetzterSelect &&
							<SessionInfoTableRow label={'Vorgesetzter'}>
								<VorgesetzterUserSelect vorgesetzterUser={vorgesetzterUser}/>
							</SessionInfoTableRow>
							}
							{showAltMandantSelect &&
							<SessionInfoTableRow label={'Mandant'}>
								<MandantSelect
									mandant={mandant}
									alternativeMandants={alternativeMandants}
									defaultMandant={defaultMandant}/>
							</SessionInfoTableRow>
							}
							{mailVertretungRendered &&
							<SessionInfoTableRow label={'E-Mail Vertretung'}>
								<EwsRepSelectList ewsRepList={ewsRepList}/>
							</SessionInfoTableRow>
							}
							<SessionInfoTableRow label={'Benutzergruppe'}>
								{evoAppsUser.userGroup.id}
							</SessionInfoTableRow>
							<SessionInfoTableRow label={'Personalnummer'}>
								{evoAppsUser.persNr}
							</SessionInfoTableRow>
							<SessionInfoTableRow label={'E-Mail'}>
								{evoAppsUser.email}
							</SessionInfoTableRow>
							<SessionInfoTableRow label={'App-Cache'}>
								<DeleteLocalCacheButton/>
							</SessionInfoTableRow>
						</SessionInfoTable>
					</form>
				</AccordionDetails>
			</ExpansionPanel>
			{costCenter.panelRendered &&
			<ExpansionPanel
				{...panelProps}
				expanded={expandedCostCenter}
				onChange={expandedCostCenterCb}
			>
				<ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
					Aktuelle Kontierung
				</ExpansionPanelSummary>
				<AccordionDetails>
					<KostComponent kostInfo={costCenter}/>
				</AccordionDetails>
			</ExpansionPanel>
			}
			{calculation.panelRendered &&
			<ExpansionPanel
				{...panelProps}
				expanded={expandedCalculation}
				onChange={expandedCalculationCb}
			>
				<ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
					Gültig erfasst bis {getSisDateAsISO(calculation && calculation.clearedToDate)}
				</ExpansionPanelSummary>
				<AccordionDetails>
					<VlErrorList models={calculation.errorMessages}/>
				</AccordionDetails>
			</ExpansionPanel>
			}
			{personalInfo.panelRendered &&
			<ExpansionPanel
				{...panelProps}
				expanded={expandedPersonalInfo}
				onChange={expandedPersonalInfoCb}
			>
				<ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
					Information
				</ExpansionPanelSummary>
				<AccordionDetails>
					<PersonInfoList models={personalInfo.infos}/>
				</AccordionDetails>
			</ExpansionPanel>
			}
			{passwordPanelRendered &&
			<ExpansionPanel
				{...panelProps}
				expanded={expandedPassword}
				onChange={expandedPasswordCb}
			>
				<ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
					Passwort
				</ExpansionPanelSummary>
				<AccordionDetails>
					<ChangePasswordComponent/>
				</AccordionDetails>
			</ExpansionPanel>
			}
			<DialogActionsPaper>
				<DialogActions>
					<Button size={'large'} onClick={logout}><PowerSettingsNewIcon/>&nbsp;Abmelden</Button>
					<Button size={'large'} onClick={openHelp}><HelpOutlinedIcon/>&nbsp;Hilfe</Button>
				</DialogActions>
			</DialogActionsPaper>
		</Modal>
	)
});